import CorporationService from '../../../services/corporation/corporationService';
const api = new CorporationService()
const state = {
    corporations: [],
    loading_corporations:false,
    manageResultRequestCorporation:{}
};
const getters = {
    StateCorporations: state => state.corporations,
    StateLoadingCorporation: state => state.loading_corporations,
};
const mutations = {
    setCorporations(state, value){ state.corporations = value },
    setLoadingCorporation(state, value){ state.loading_corporations = value },
};
const actions = {
    async ListCorporations({commit}, params={}) {
        commit('setLoadingCorporation', true)
        // await dispatch('verifyToken')
        try{
            let response = await api.get('',{...params, page_size:100})
            commit('setCorporations', response.data.results)
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setLoadingCorporation', false)
    },
};
export default {
  state,
  getters,
  actions,
  mutations
};